import React from 'react'
import { GET_APP_SETTING_BY_NAME, GET_REINSTATEMENT_FORM_DEFINITION_ID, GET_AR_FORM_DEFINITION_ID } from 'requests'
import { Link } from 'react-router-dom'
import ReactMarkdown from 'components/Markdown/Markdown'
import { Spinner } from 'components/Loaders/Loaders'
import ActionButton, { ActionButtonGroup } from '../ActionButton/ActionButton';

export default class ReinstatementLauncher extends React.Component {
	state = {
	  textLoading: true,
	  reinstatementFormDefinitionId: null,
	  annualReportFormDefinitionId: null,
	  fIdLoading: true,
	  arIdLoading: true,
	  text: ""
	}
	componentDidMount = () => {
		if(this.state.textLoading === true){
			this.getReinstatementText()
			if(this.props.canFileReinstatement){
				this.GetReinstatementFormDefinitionId()
			}else{
				this.setState({fIdLoading: false})
			}
			if(this.props.canFileAR){
				this.GetAnnualReportFormDefinitionId()
			}else{
				this.setState({arIdLoading: false})
			}
		}
	}
	getReinstatementText = () => {
		GET_APP_SETTING_BY_NAME('REINSTATEMENT_INSTRUCTIONS_PARAGRAPH', res => {
			this.setState({
				textLoading: false,
				text: res.VALUE
			})
		})
	}
	GetReinstatementFormDefinitionId = () => {
		GET_REINSTATEMENT_FORM_DEFINITION_ID(this.props.filingNum, formDefinitionId => {
			this.setState({
				fIdLoading: false,
				reinstatementFormDefinitionId: formDefinitionId
			})
		}, err => {
			console.error(err)
		})
	}
	GetAnnualReportFormDefinitionId = () => {
		GET_AR_FORM_DEFINITION_ID(this.props.filingNum, formDefinitionId => {
			this.setState({
				arIdLoading: false,
				annualReportFormDefinitionId: formDefinitionId
			})
		}, err => {
			console.error(err)
		})
	}
	render() {
		const {
			text,
			textLoading,
			fIdLoading,
			arIdLoading
		} = this.state
		const {
			filingNum,
			canFileAR,
			canFileReinstatement
		} = this.props
		return (
			textLoading || fIdLoading || arIdLoading ?
			<div className='reinstatement center'>
				<Spinner themeColor='medium-neutral' />
			</div>
			:
			<div className="reinstatement">
				<ReactMarkdown source={text} className="markdown instructions"/>
				<ActionButtonGroup className="details-actions-bottom">
					<Link to={`/amend/${this.state.annualReportFormDefinitionId}/${filingNum}`} className={canFileAR ? null : "disabled-link"}>
						<ActionButton label='File Annual Report' iconClass="icon icon-report" onClick={null} />
					</Link>
					<Link to={`/amend/${this.state.reinstatementFormDefinitionId}/${filingNum}`} className={canFileReinstatement ? null : "disabled-link"}>
						<ActionButton label='File Reinstatement' iconClass="icon icon-report" onClick={null} />
					</Link>
				</ActionButtonGroup>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/MyRecords/ReinstatementLauncher.js